export default "__VITE_ASSET__cf70f08a__"